<app-base-pesquisa #modal titulo="Pesquisa de CID-10" subtitulo="Clique duas vezes em cima da linha do registro para realizar a seleção." 
    (registroSelecionado)="selecionado($event)">
    <ng-template appFiltroPesquisa>
        <div class="form-group">
            <input type="button" ejs-button iconCss="fas fa-search" value="Atualizar" (click)="atualizar()" cssClass="e-primary btn-block"/>
        </div>
    </ng-template>
    <ng-template appConteudoPesquisa>
        <ejs-grid #grid appGridPesquisa
            [dataSource]="registros"
            [allowPaging]="true"
            
            [height]="'100%'" 
            
            [rowHeight]="30"

            [pageSettings]="initialPage"

            [toolbar]="toolbar"

            (created)="calculatePageSize()"
        
            [selectionSettings]="{enableToggle: false}"
            [allowFiltering]='false' 
            [allowSorting]='true' 
            [allowResizing]='true' 

            [showColumnChooser]='false'
            [showColumnMenu]='false'
           
            [allowExcelExport]='false'
            [allowPdfExport]='false'>
            <e-columns>
                <e-column field='codigo' [headerText]="'Código'" [isPrimaryKey]="true"></e-column>
                <e-column field='descricao' [headerText]="'Descrição'"></e-column>
                <e-column field="drt" [displayAsCheckBox]="true" headerText="DRT" width="100"></e-column>
            </e-columns>

        <!--    <e-aggregates>
                <e-aggregate>
                    <e-columns>
                        <e-column field="codigo" type="count">
                            <ng-template #footerTemplate let-data><b>Total: {{data.count}}</b></ng-template>
                        </e-column>
                    </e-columns>
                </e-aggregate>
            </e-aggregates>-->

        </ejs-grid>
    </ng-template>
</app-base-pesquisa>
